import script from "./result_entry.vue?vue&type=script&setup=true&lang=ts"
export * from "./result_entry.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__